/* The person: initials in a ring on the surface; a small menu underneath. CapturePoint's tokens
   only, so the mark reads the same on the dashboard and inside the workbench's chrome. */
.profile {
  position: relative;
}
.profile__button {
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;
}
.profile__avatar {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--cp-text-primary);
  background: var(--cp-surface-raised);
  border: 1px solid var(--cp-border-default);
  transition:
    border-color var(--paige-motion-fast) ease,
    background var(--paige-motion-fast) ease;
}
.profile__button:hover .profile__avatar,
.profile__button:focus-visible .profile__avatar {
  border-color: var(--paige-accent);
  background: var(--paige-accent-soft);
}
.profile__button:focus-visible {
  outline: none;
}
.profile__button:focus-visible .profile__avatar {
  box-shadow: 0 0 0 2px var(--paige-focus-halo);
}
.profile__button {
  position: relative;
  z-index: 4;
}
/* The menu opens from the mark's own corner and grows left and down, so the pointer stays inside
   it whichever way it moves. */
.profile__menu {
  position: absolute;
  top: -9px;
  right: -9px;
  min-width: 240px;
  padding: 56px 8px 8px;
  border-radius: 10px;
  border: 1px solid var(--cp-border-subtle);
  background: var(--cp-surface);
  box-shadow: var(--cp-shadow-elevated);
  z-index: 3;
  animation: menu-in var(--paige-motion-fast) ease-out both;
}
@keyframes menu-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.profile__name {
  padding: 8px 12px 10px;
  font-size: 13px;
  color: var(--cp-text-muted);
  border-bottom: 1px solid var(--cp-border-subtle);
  margin-bottom: 6px;
}
.profile__menu button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 9px 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--cp-text-primary);
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.profile__menu button:hover,
.profile__menu button:focus-visible {
  background: var(--cp-surface-hover);
  outline: none;
}
.profile__theme {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px;
  margin: 6px 0 2px;
  padding-top: 8px;
  border-top: 1px solid var(--cp-border-subtle);
}
.profile__menu .profile__theme button {
  justify-content: center;
  padding: 8px 4px;
  color: var(--cp-text-muted);
}
.profile__menu .profile__theme button.is-on {
  color: var(--cp-text-primary);
  background: var(--paige-accent-soft);
  box-shadow: inset 0 0 0 1px var(--cp-border-default);
}
.profile__menu .profile__out {
  justify-content: flex-start;
  color: var(--cp-text-secondary);
  margin-top: 4px;
}
.profile__icon {
  display: inline-flex;
}

@media (prefers-reduced-motion: reduce) {
  .profile__menu {
    animation: none;
  }
}
